import React from 'react';

import PageHeaderMenu from 'components/shared/LandingPage/blocks/PageHeader/PageHeaderMenu';
import { BurgerMenu } from 'detailsv2/LandingV2/Header/TopBar/BurgerMenu';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import { useGuestPortalData } from '../functions';
import s from './index.module.css';

export const LeftActions = () => {
  const { isTabletOrMobile } = useMediaBreakpoints();
  const { actions } = useGuestPortalData();

  return (
    <div className={s.actionsContainer}>
      <BurgerMenu />
      {!isTabletOrMobile && <PageHeaderMenu actions={actions} />}
    </div>
  );
};
